/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticatedResponse,
  ErrorResponse,
  ResendConfirmEmailInput,
  ResetPasswordInput,
  ResetPasswordSendLinkInput,
  SignInCredentials,
  SignUpCredentials,
  UserData,
} from '../models/index';
import {
    AuthenticatedResponseFromJSON,
    AuthenticatedResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ResendConfirmEmailInputFromJSON,
    ResendConfirmEmailInputToJSON,
    ResetPasswordInputFromJSON,
    ResetPasswordInputToJSON,
    ResetPasswordSendLinkInputFromJSON,
    ResetPasswordSendLinkInputToJSON,
    SignInCredentialsFromJSON,
    SignInCredentialsToJSON,
    SignUpCredentialsFromJSON,
    SignUpCredentialsToJSON,
    UserDataFromJSON,
    UserDataToJSON,
} from '../models/index';

export interface CheckResetTokenRequest {
    token: string;
}

export interface ConfirmEmailRequest {
    token: string;
}

export interface ConfirmInvitationRequest {
    token: string;
}

export interface ResendConfirmationLinkRequest {
    resendConfirmEmailInput?: ResendConfirmEmailInput;
}

export interface ResetPasswordRequest {
    resetPasswordInput?: ResetPasswordInput;
}

export interface ResetPasswordLinkRequest {
    resetPasswordSendLinkInput?: ResetPasswordSendLinkInput;
}

export interface SignInRequest {
    signInCredentials: SignInCredentials;
}

export interface SignUpRequest {
    signUpCredentials: SignUpCredentials;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Returns email of 
     */
    async checkResetTokenRaw(requestParameters: CheckResetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserData>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling checkResetToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/user/reset-password/check-token/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDataFromJSON(jsonValue));
    }

    /**
     * Returns email of 
     */
    async checkResetToken(requestParameters: CheckResetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserData> {
        const response = await this.checkResetTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms user email with token.
     */
    async confirmEmailRaw(requestParameters: ConfirmEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling confirmEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/user/confirm-email/check/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Confirms user email with token.
     */
    async confirmEmail(requestParameters: ConfirmEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.confirmEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms user email with token.
     */
    async confirmInvitationRaw(requestParameters: ConfirmInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling confirmInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/user/confirm-invitation/check/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Confirms user email with token.
     */
    async confirmInvitation(requestParameters: ConfirmInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.confirmInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-sends link to confirm email address.
     */
    async resendConfirmationLinkRaw(requestParameters: ResendConfirmationLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/user/confirm-email/resend`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendConfirmEmailInputToJSON(requestParameters['resendConfirmEmailInput']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Re-sends link to confirm email address.
     */
    async resendConfirmationLink(requestParameters: ResendConfirmationLinkRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resendConfirmationLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates password by using the reset password token.
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/user/reset-password/update-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordInputToJSON(requestParameters['resetPasswordInput']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates password by using the reset password token.
     */
    async resetPassword(requestParameters: ResetPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends link to reset password to the user by the e-mail address.
     */
    async resetPasswordLinkRaw(requestParameters: ResetPasswordLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/user/reset-password/send-link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordSendLinkInputToJSON(requestParameters['resetPasswordSendLinkInput']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sends link to reset password to the user by the e-mail address.
     */
    async resetPasswordLink(requestParameters: ResetPasswordLinkRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resetPasswordLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets user, password and returns auth token.
     */
    async signInRaw(requestParameters: SignInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        if (requestParameters['signInCredentials'] == null) {
            throw new runtime.RequiredError(
                'signInCredentials',
                'Required parameter "signInCredentials" was null or undefined when calling signIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/sign-in`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignInCredentialsToJSON(requestParameters['signInCredentials']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Gets user, password and returns auth token.
     */
    async signIn(requestParameters: SignInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.signInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates user by email and password.
     */
    async signUpRaw(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['signUpCredentials'] == null) {
            throw new runtime.RequiredError(
                'signUpCredentials',
                'Required parameter "signUpCredentials" was null or undefined when calling signUp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/sign-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignUpCredentialsToJSON(requestParameters['signUpCredentials']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates user by email and password.
     */
    async signUp(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.signUpRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
